import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TableCell, TableRow, Chip } from '@mui/material'

import {
  TableMenuButtonComponent,
  TableMenuComponent,
  TableMenuOptions,
} from '@/views/components'
import { RoleType } from '@/enums'
import useHasAccess from '@/hooks/use-access.hook'

import { BrandsLibraryColumnProps } from '@/state/user/models'

type Props = {
  row: BrandsLibraryColumnProps
  handleEditBrand: (brandId: number) => void
  handleDeleteBrand: (
    anchorPosition: {
      top: number
      left: number
    },
    brandId: number,
  ) => void
}

export const BrandsTableRowComponent = ({
  row,
  handleDeleteBrand,
  handleEditBrand,
}: Props) => {
  const { t } = useTranslation()

  const { hasAccess } = useHasAccess()

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const canDelete = !hasAccess(RoleType.AGENT) && !row.enable

  const canEdit = !hasAccess(RoleType.AGENT)

  const handleClickButton = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    type: TableMenuOptions,
  ) => {
    const anchorPosition = {
      top: anchorEl?.getBoundingClientRect().top || event.clientY,
      left: anchorEl?.getBoundingClientRect().left || event.clientX,
    }
    type === 'delete' && handleDeleteBrand(anchorPosition, row.id)
    type === 'edit' && handleEditBrand(row.siteId)

    setAnchorEl(null)
  }

  return (
    <>
      <TableRow hover role="checkbox">
        <TableCell>
          <Chip
            variant="filled"
            size="medium"
            label={t(`${row.enable ? 'labels.active' : 'labels.inactive'}`)}
            className={`${row.enable ? 'green' : 'red'}`}
            sx={{ width: '100%' }}
          />
        </TableCell>
        <TableCell>{row.name}</TableCell>
        <TableCell>{row.siteId}</TableCell>
        {process.env.REACT_APP_STAGE !== 'prod' && (
          <TableCell>{row.operatorId || '-'}</TableCell>
        )}
        <TableCell>
          {row.currencies.map((currency) => {
            return (
              <Chip
                variant="filled"
                size="medium"
                label={currency}
                sx={{ m: 0.5 }}
                key={currency}
              />
            )
          })}
        </TableCell>
        <TableMenuButtonComponent setAnchorEl={setAnchorEl} />
      </TableRow>
      <TableMenuComponent
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        handleClickButton={handleClickButton}
        canDelete={canDelete}
        canEdit={canEdit}
      />
    </>
  )
}
